// Components
import Svg from 'src/Components/shared/Svg'

export const PlusSvg = props => (
  <Svg
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 7.35714V9.64286H9.14286V16.5H6.85714V9.64286H0V7.35714H6.85714V0.5H9.14286V7.35714H16Z'
      fill='var(--brand-neutral-warm-500)'
    />
  </Svg>
)
